import { DEVICE_LINKING } from '../../constants/device-linking';

type Props = {
  linkCodeInput: string;
  isLinking: boolean;
  isAtLimit: boolean;
  onInputChange: (text: string) => void;
  onLink: () => void;
};

export default function EnterLinkCodeSection({
  linkCodeInput,
  isLinking,
  isAtLimit,
  onInputChange,
  onLink,
}: Props) {
  const canLink =
    linkCodeInput.length === DEVICE_LINKING.CODE_LENGTH && !isAtLimit;

  return (
    <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-gray-50 rounded-lg">
      <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-gray-900">
        Enter Link Code
      </h3>
      <p className="text-base text-gray-600 mb-3 sm:mb-4">
        Enter the {DEVICE_LINKING.CODE_LENGTH}-digit code from your other
        device to link them together.
      </p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="text"
          value={linkCodeInput}
          onChange={(e) => onInputChange(e.target.value)}
          placeholder="000000"
          maxLength={DEVICE_LINKING.CODE_LENGTH}
          className="flex-1 px-3 sm:px-4 py-2.5 sm:py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-center text-xl sm:text-2xl font-mono tracking-widest"
        />
        <button
          onClick={onLink}
          disabled={isLinking || !canLink}
          className="w-full sm:w-auto px-6 py-2.5 sm:py-3 bg-green-700 text-white rounded-lg hover:bg-green-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium text-base whitespace-nowrap">
          {isLinking ? 'Linking...' : 'Link Devices'}
        </button>
      </div>
    </div>
  );
}

